export default __webpack_public_path__ + "static/media/mypage-img.d0d33dfa.jpg";